import { render, staticRenderFns } from "./AllExamineDetail.vue?vue&type=template&id=131e54e8&scoped=true"
import script from "./AllExamineDetail.vue?vue&type=script&lang=js"
export * from "./AllExamineDetail.vue?vue&type=script&lang=js"
import style0 from "./AllExamineDetail.vue?vue&type=style&index=0&id=131e54e8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "131e54e8",
  null
  
)

export default component.exports